import Vue from "vue";
import Vuex from "vuex";
import Cookies from 'js-cookie';
import authModule from "@/modules/auth/store/authStore";
import accountModule from "@/modules/account/store/accountStore";
import upgradeAccountModule from "@/modules/upgradeAccount/store/upgradeAccountStore";
import brandModule from "@/modules/common/store/brandingModule/brandingStore";
import todo from "@/modules/common/store/todoModule/todoStore";
import clientFields from "@/modules/settings/store/clientFieldsStore";
import quickActionsModule from "@/modules/settings/store/quickActionsStore";
import marketingWizard from "@/modules/wizards/MarketingWizard/marketingWizardStore";
import paymentWizard from "@/modules/wizards/PaymentWizard/paymentWizardStore";
import mattersModule from "@/modules/matters/store/mattersStore";
import campaignsGalleryModule from "@/modules/marketing/store/campaignsGalleryStore";
import productModule from "@/modules/products/store/productStore"
import auditlogModule from "@/modules/auditlog/store/auditlogStore"
import paymentsModule from "@/modules/payments/store/paymentsStore.js"
import vaultedCardsModule from "@/modules/payments/store/vaultedCardsStore.js"
import xpertWizardModule from "@/modules/wizards/XpertWizard/xpertWizardStore";
import bookingFiltersModule from "@/modules/bookings/store/bookingFilterStore";
import productOrderModule from "@/modules/productOrder/store/productOrderStore";
import itemizableModule from "@/modules/itemizable/store/itemizableStore";
import packagesModule from "@/modules/packages/store/packagesStore.js"
import reportsModule from "@/modules/reports/store/reportsStore";
import appMarketModule from "@/modules/appMarket/store/appMarketStore";
import staffAddOnModule from "@/modules/addonsPurchased/store/staffStore.js";
import mobileAppModule from "@/modules/mobileApp/store/mobileAppStore";
import notificationCenterModule from "@/modules/notificationCenter/store/notificationCenterStore";
import schedulerModule from "@/modules/scheduler/store/schedulerStore";
import availabilityModule from "@/modules/availability/store/availabilityStore";
import notificationsSettingsModule from "@/modules/notificationSettings/store/notificationsSettingsStore";
import settingsModule from "@/modules/settings/store/settingsStore";
import campaignTriggerModule from "@/modules/marketing/store/campaignTriggerStore";
import calendarSettingsModule from "@/modules/settings/store/calendarSettingsStore";
import saleModule from "@/modules/sale/store/saleStore";
import businessModule from "@/modules/business/store/businessStore";
import smsModule from "@/modules/addonsPurchased/store/smsStore";
import channelsModule from "@/modules/channels/store/channelsStore";

Vue.use(Vuex);

const debug = window.vue_config.NODE_ENV !== "production";

const state = {
  isAndroid: false,
  isiPhone: false,
  isiPad: false,
  isTouchScreen: false,
  isChromeIos: false,
  isMobileApp: false,
  isMobile: false,
  isCordovaApp: false,
  isPane: false,
  angularOrigin: '',
  lang: 'en',
  direction: 'ltr',
  dialogStatus: {
    isOpen: false
  },
  showLoader: false,
  windowLocation: false,
  dialogIndex: 0
}

const mutations = {
  setIsAndroid(state, isAndroid) {
    state.isAndroid = isAndroid
  },
  setIsiPhone(state, isiPhone) {
    state.isiPhone = isiPhone
  },
  setIsiPad(state, isiPad) {
    state.isiPad = isiPad
  },
  setIsTouchScreen(state, isTouchScreen) {
    state.isTouchScreen = isTouchScreen
  },
  setChromeIos(state, isChromeIos) {
    state.isChromeIos = isChromeIos
  },
  setMobileApp(state, isMobileApp) {
    state.isMobileApp = isMobileApp
  },
  setMobile(state, isMobile) {
    state.isMobile = isMobile
  },
  setCordovaApp(state, isCordovaApp) {
    state.isCordovaApp = isCordovaApp
  },
  setPane(state, isPane) {
    state.isPane = isPane
  },
  setAngularOrigin(state, origin) {
    state.angularOrigin = origin
  },
  setLang(state, lang) {
    state.lang = lang
  },
  setDialogStatus(state, dialogStatus) {
    state.dialogStatus = dialogStatus
  },
  setDirection(state, direction) {
    state.direction = direction
  },
  setLoaderState(state, showLoader) {
    state.showLoader = showLoader
  },
  setWindowLocation(state, value) {
    state.windowLocation = value
  },
  increaseDialogIndex(state) {
    state.dialogIndex++;
  },
  decreaseDialogIndex(state) {
    state.dialogIndex--;
  }
}

const actions = {
  initWindowLocation: ({commit}) => {
    commit("setWindowLocation", window.app_config.frontage_location)
  }
};

const getters = {
  isAndroid: function (state) {
    return state.isAndroid
  },
  isiPhone: function (state) {
    return state.isiPhone
  },
  isiPad: function (state) {
    return state.isiPad
  },
  isTouchScreen: function (state) {
    return state.isTouchScreen
  },
  isChromeIos: function (state) {
    return state.isChromeIos
  },
  isMobileApp: function (state) {
    return state.isMobileApp
  },
  isIosMobileApp: function (state) {
    return (state.isiPhone || state.isiPad) && state.isMobileApp
  },
  isIOS: function (state) {
    return (state.isiPhone || state.isiPad)
  },
  isMobile: function (state) {
    return state.isMobile
  },
  isCordovaApp: function (state) {
    return state.isCordovaApp
  },
  isPane: function (state) {
    return state.isPane
  },
  angularOrigin: function (state) {
    return state.angularOrigin
  },
  isSmallScreen: function (state) {
    return state.isMobile || state.isMobileApp
  },
  lang: function (state) {
    return state.lang
  },
  direction: function (state) {
    return state.direction
  },
  platform: function (state) {
    return state.isMobileApp ? 'mobileApp' : (state.isMobile ? 'mobile' : 'desktop')
  },
  isRightToLeft: function (state) {
    return state.direction === 'rtl'
  },
  vcitaWindowLocation: function (state) {
    return state.windowLocation.includes('vcita')
  },
  isNewPovLayoutMobile: (state, getters, rootState, rootGetters) => {
    return state.isMobile && rootGetters.hasFeature('redirect_to_pov');
  },
  dialogStatus: state => state.dialogStatus,
  showLoader: state => state.showLoader,
  dialogIndex: state => state.dialogIndex,
  isImpersonate: () => !!Cookies.get('impersonated_id'),
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    brandModule,
    businessModule,
    todo,
    clientFields,
    paymentWizard,
    marketingWizard,
    auth: authModule,
    accountModule,
    upgradeAccountModule,
    mattersModule,
    quickActionsModule,
    campaignsGalleryModule,
    xpertWizardModule,
    productModule,
    auditlogModule,
    paymentsModule,
    vaultedCardsModule,
    bookingFiltersModule,
    productOrderModule,
    itemizableModule,
    packagesModule,
    reportsModule,
    appMarketModule,
    staffAddOnModule,
    mobileAppModule,
    notificationCenterModule,
    schedulerModule,
    availabilityModule,
    notificationsSettingsModule,
    campaignTriggerModule,
    settingsModule,
    calendarSettingsModule,
    saleModule,
    smsModule,
    channelsModule
  },
  strict: debug
});
